/**
 * @generated SignedSource<<408584fbd038f922a4eb134da26a959a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShareButton_node$data = {
  readonly __typename: string;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"AnnouncementButton_node" | "CopyLinkButton_node" | "DownloadButton_node" | "ReminderButton_node" | "ShortcutButton_node" | "WebShareButton_node">;
  readonly " $fragmentType": "ShareButton_node";
};
export type ShareButton_node$key = {
  readonly " $data"?: ShareButton_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShareButton_node">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShareButton_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CopyLinkButton_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WebShareButton_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DownloadButton_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnnouncementButton_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShortcutButton_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReminderButton_node"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "628ecb06fd8391e1c383261db4405ea3";

export default node;
